import { REDUX_BASKET_UPDATED, REDUX_SHOPLIST_UPDATED } from './actions';
import { PayloadProps, Layers } from './types';

// TODO: FIXME разделить логику? возможно создать отдельный редюсер для вишлиста
// заменить захардкоженые экшены 'products/ADD_TO_SHOPLIST' и 'products/REMOVE_FROM_SHOPLIST'
export function createReducer(initialState: Layers) {
  return function reducer(
    // eslint-disable-next-line @typescript-eslint/default-param-last
    state = initialState,
    action: {
      type:
        | typeof REDUX_BASKET_UPDATED
        | typeof REDUX_SHOPLIST_UPDATED
        | 'products/ADD_TO_SHOPLIST'
        | 'products/REMOVE_FROM_SHOPLIST';
      payload: PayloadProps[];
    },
  ) {
    switch (action.type) {
      case REDUX_BASKET_UPDATED:
        return {
          ...state,
          basket: action.payload.map((item) => item.code),
          basketWithQuantity: action.payload,
        };
      case REDUX_SHOPLIST_UPDATED:
        return {
          ...state,
          shoppingList: action.payload.map((item) => item.code),
        };
      case 'products/ADD_TO_SHOPLIST':
        if (typeof action.payload === 'string') {
          return {
            ...state,
            shoppingList: [...state.shoppingList, action.payload],
          };
        }
        return state;
      case 'products/REMOVE_FROM_SHOPLIST':
        if (typeof action.payload === 'string') {
          const shoppingList = new Set(state.shoppingList);
          shoppingList.delete(action.payload);

          return {
            ...state,
            shoppingList: Array.from(shoppingList),
          };
        }
        return state;
      default:
        return state;
    }
  };
}
